module.exports = __webpack_public_path__ + "static/media/poste_6.9f9c2cb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_6.jpg
// module id = 263
// module chunks = 0